import React, {
  createContext, useState, useMemo, useEffect,
} from 'react';
import PropTypes from 'prop-types';

export const PaymentContext = createContext();

const PaymentContextProvider = ({ children }) => {
  // Initialize from localStorage if available
  const [sid1, setSid1] = useState('');
  const [market1, setMarket1] = useState(() => localStorage.getItem('market1') || 'USA');
  const [journey1, setJourney1] = useState(() => localStorage.getItem('journey1') || 'pbp');
  const [paymentResponse, setPaymentResponse] = useState(null);
  const [confirmationCode, setConfirmationCode] = useState('');
  const [u1, setU1] = useState(() => localStorage.getItem('u1') || '');
  const [paymentSchedule, setPaymentSchedule] = useState(false);
  const [metaData, setMetaData] = useState(null);
  const [env, setEnv] = useState(null);

  // Persist to localStorage when changed
  useEffect(() => {
    localStorage.setItem('market1', String(market1));
  }, [market1]);
  useEffect(() => {
    localStorage.setItem('journey1', String(journey1));
  }, [journey1]);
  useEffect(() => {
    localStorage.setItem('u1', String(u1));
  }, [u1]);

  const contextValue = useMemo(() => ({
    paymentResponse,
    market1,
    journey1,
    sid1,
    env,
    setSid1,
    setMarket1,
    setJourney1,
    setPaymentResponse,
    setConfirmationCode,
    confirmationCode,
    u1,
    setU1,
    paymentSchedule,
    setPaymentSchedule,
    metaData,
    setMetaData,
    setEnv,
  }), [journey1, market1, paymentResponse, confirmationCode, sid1, u1,
    paymentSchedule, metaData, env]);

  return (
    <PaymentContext.Provider value={contextValue}>
      {children}
    </PaymentContext.Provider>
  );
};

export default PaymentContextProvider;

PaymentContextProvider.propTypes = {
  children: PropTypes.node,
};
